import {Pipe, PipeTransform} from '@angular/core';
import {Locale} from "date-fns";
import {formatInTimeZoneForDisplay} from '../utils/format-in-time-zone-for-display';


@Pipe({
    name: 'formatInTimeZone',
    standalone: true
})
export class FormatInTimeZonePipe implements PipeTransform {

  /**
   * You can use the angular formatStrings or the date-fns formatStrings.
   *
   * Angular formatStrings:
   *
   * | Option             | Equivalent to                       | Examples (given in `en-US` locale)              |
   * |--------------------|-------------------------------------|-------------------------------------------------|
   * | `'short'`          | `'M/d/yy, h:mm a'`                  | `6/15/15, 9:03 AM`                              |
   * | `'medium'`         | `'MMM d, y, h:mm:ss a'`             | `Jun 15, 2015, 9:03:01 AM`                      |
   * | `'long'`           | `'MMMM d, y, h:mm:ss a z'`          | `June 15, 2015 at 9:03:01 AM GMT+1`             |
   * | `'full'`           | `'EEEE, MMMM d, y, h:mm:ss a zzzz'` | `Monday, June 15, 2015 at 9:03:01 AM GMT+01:00` |
   * | `'date'`           | `'M/d'`                             | `6/15`                                       |
   * | `'shortDate'`      | `'M/d/yy'`                          | `6/15/15`                                       |
   * | `'mediumDate'`     | `'MMM d, y'`                        | `Jun 15, 2015`                                  |
   * | `'longDate'`       | `'MMMM d, y'`                       | `June 15, 2015`                                 |
   * | `'fullDate'`       | `'EEEE, MMMM d, y'`                 | `Monday, June 15, 2015`                         |
   * | `'shortTime'`      | `'h:mm a'`                          | `9:03 AM`                                       |
   * | `'mediumTime'`     | `'h:mm:ss a'`                       | `9:03:01 AM`                                    |
   * | `'longTime'`       | `'h:mm:ss a z'`                     | `9:03:01 AM GMT+1`                              |
   * | `'fullTime'`       | `'h:mm:ss a zzzz'`                  | `9:03:01 AM GMT+01:00`                          |
   *
   **/

  transform(date: Date | string | number,
            locale: Locale,
            formatStr: string | 'short' | 'medium' | 'long' | 'full' | 'date' | 'shortDate' | 'mediumDate' | 'longDate' | 'fullDate' | 'shortTime' | 'mediumTime' | 'longTime' | 'fullTime'  = 'medium',
            timeZone = 'Europe/Berlin'
  ): string {
    return formatInTimeZoneForDisplay(date,locale,formatStr,timeZone);
  }
}
